import $ from "jquery";

const sections = [];

function initSectionConfig() {
    const wsid = $("body").data("wsid");
    const tplid = $("body").data("tplid");

    if(wsid == 1) {
        //Home
        /*sections.push({
            color: "red",
            startPosition: function() {
                const $bl = $(".bl-textwithimage").first();
                return $bl.offset().top + $bl.find(".colimage").height()*0.5;
                //return window.innerHeight;
            },
            endPosition: function() {
                const $bl = $(".bl-einblick").first();
                return $bl.offset().top + $bl.find(".ctrimage1").height()*0.33;
            }
        });*/

        sections.push({
            color: "red",
            startPosition: function() {
                const $bl = $(".bl-textwithimage").last();
                return $bl.offset().top + $bl.find(".colimage").height()*0.5;
            },
            endPosition: function() {
                return $("footer").offset().top;
            }
        });
    } else if(wsid == 48) {
        //Programm
        sections.push({
            color: "red",
            startPosition: function() {
                const $bl = $(".bl-fourimg").first();
                return $bl.offset().top + $bl.find(".ctrimg1").height()*0.8;
            },
            endPosition: function() {
                return $("footer").offset().top;
            }
        });
    } else if(tplid == 3) {
        //Objekt Detail
        sections.push({
            color: "red",
            startPosition: function() {
                const $elem = $(".bl-textwithimage").first().find(".at-imglegend");
                return $elem.offset().top+$elem.height()+getLayoutGridGap();
            },
            endPosition: function() {
                const $bl = $(".bl-objdetail-threeimg").first();
                return $bl.offset().top-getLayoutGridGap();
            }
        });
    }
} 

function getLayoutGridGap() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--layoutgridgap"))*parseInt(getComputedStyle(document.documentElement).fontSize);
}

function initSections() {
    initSectionConfig();

    const $bgcolorsections = $("#bgcolorsections");

    for(const section of sections) {
        const $section = $('<div class="bgcolorsection"></div>');
        $section.addClass("color-"+section.color);
        section.$element = $section;
        $bgcolorsections.append($section);
    }

    positionSections();
    $(window).on("load", positionSections);
    $(window).on("resize", function() {
        window.requestAnimationFrame(positionSections)
    });
}

function positionSections() {
    for(const section of sections) {
        const $section = section.$element;
        
        const posStart = section.startPosition();
        const posEnd = section.endPosition();

        $section.css({
            "top": posStart+"px",
            "height": (posEnd-posStart)+"px"
        });
    }
}

$(initSections);
